import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <header className="header">
      <h1>横浜国立大学共通テスト偏差値換算サイト</h1>
    </header>
  );
};

export default Header;
